import store from '@/store/index';
import errorIcon from '@/assets/images/icons/error.svg';
import successIcon from '@/assets/images/icons/success.svg';
import i18n from '@/lang';

const fileOperation = {

  /**
   * 上傳
   * @param {function} uploadApiMethod 上傳Api的方法
   * @param {Object} apiParams 上傳Api的參數
   * @param {function} callback success callback
   * @param {function} errorHandler error callback
   */
  async upload(uploadApiMethod, apiParams, callback = null, errorHandler = null) {
    if (!apiParams) {
      return null;
    }
    const res = await uploadApiMethod(apiParams);

    // 上傳失敗
    if (res.errorStatus) {
      if (errorHandler) {
        errorHandler(res);
      } else {
        store.dispatch('alert/setAlertInfo', {
          icon: errorIcon,
          title: i18n.t('global.msg_uploadFailed'),
          desc: res.message || '未預期的錯誤，請聯絡工程人員',
          buttons: [
            {
              key: 'confirm',
              text: i18n.t('global.btn_comfirm'),
              btnStyle: 'btn-primary btn-round',
              onClick: () => store.dispatch('alert/closeAlert'),
            },
          ],
        });
      }
      return res;
    }

    if (callback) {
      callback(res);
    } else {
      // 上傳成功
      store.dispatch('alert/setAlertInfo', {
        icon: successIcon,
        title: i18n.t('global.msg_uploadSucess'),
        desc: '已更新版本',
        autoClose: true,
      });
    }

    if (res.data instanceof Blob) {
      // 解析 Blob，獲得金鑰
      const getFileToken = (blob) => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsText(blob);
      });
      return getFileToken(res.data);
    }
    return res;
  },

  /**
   * 下載
   * @param {function} downloadApiMethod 下載Api的方法
   * @param {Object} apiParams 下載Api的參數
   * @param {Object} custom 客製化參數
   */
  async download(downloadApiMethod, apiParams, callback = null, errorHandler = null) {
    if (!apiParams) {
      return null;
    }
    const res = await downloadApiMethod(apiParams);
    if (res.errorStatus) {
      if (errorHandler) {
        errorHandler(res);
      } else {
        store.dispatch('alert/setAlertInfo', {
          icon: errorIcon,
          title: '下載失敗',
          desc: res.message || '未預期的錯誤，請聯絡工程人員',
          buttons: [
            {
              key: 'confirm',
              text: i18n.t('global.btn_comfirm'),
              btnStyle: 'btn-primary btn-round',
              onClick: () => store.dispatch('alert/closeAlert'),
            },
          ],
        });
      }
      return res;
    }
    if (callback) {
      callback(res);
    }
    this.parseAndDownloadFile(res);
    return res;
  },

  /**
   * 轉換與觸發下載
   * @param {Object} parseAndDownloadFile File HttpResponseObject
   */
  parseAndDownloadFile(response) {
    // 從response header 的conent-disposition取檔名
    let fileName;
    if (response.headers['content-disposition']) {
      fileName = decodeURI(response.headers['content-disposition'].split(';')[2].split("''")[1]);
    }
    // 下載檔案
    const bin = [response.data];
    const downloadURL = URL.createObjectURL(new Blob(bin, { type: response.headers['content-type'] }));
    const link = document.createElement('a');
    document.body.appendChild(link);
    link.href = downloadURL;
    link.download = fileName;
    link.click();
    link.remove();
    URL.revokeObjectURL(downloadURL);
  },

  /**
   * Blob解析為base64
   * @param {Blob} res blob物件
   * @returns {String} URL
   */
  parseAsURL(blob) {
    const getBase64 = (file) => new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
    return getBase64(blob);
  },

  /** 解析Blob */
  parseBlobBody(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = reject;
      reader.readAsText(blob);
    });
  },
};

export default fileOperation;
